import React from 'react';
import { Form } from 'antd';
import { FormItemProps as FormItemCopyProps } from 'antd/lib/form';

export type FormItemProps = FormItemCopyProps;

const ProFormItem: React.FC<FormItemProps> = props => {
  const { children, ...restProps } = props;
  return <Form.Item {...restProps}>{children}</Form.Item>;
};

export default ProFormItem;
